import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-510"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.501 10.3H4.525a.5.5 0 0 0 0 1h8.976a.5.5 0 0 0 0-1zM15.5 4.817h-.546a3.175 3.175 0 0 0-3.139-2.731 3.146 3.146 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.146 3.146 0 0 0-.396-.04 3.185 3.185 0 1 0 1.243 6.116 4.61 4.61 0 0 0 6.144 0 3.178 3.178 0 0 0 4.373-2.385h.555a.5.5 0 0 0 0-1zm-3.685 2.638a2.172 2.172 0 0 1-.852-.173 1 1 0 0 0-1.05.167 3.61 3.61 0 0 1-4.827 0 1 1 0 0 0-1.049-.167 2.185 2.185 0 1 1-.852-4.196 1.22 1.22 0 0 1 .168.018l.104.014a1 1 0 0 0 .96-.444 3.675 3.675 0 0 1 6.165 0 1 1 0 0 0 .961.444l.104-.014a1.22 1.22 0 0 1 .168-.018 2.187 2.187 0 0 1 2.136 1.731H6.524a.5.5 0 0 0 0 1h7.398a2.182 2.182 0 0 1-2.107 1.638zm-.831 5.158a.5.5 0 0 0-.5-.5H1.508a.5.5 0 1 0 0 1h8.976a.5.5 0 0 0 .5-.5zm1.11 1.344H3.118a.5.5 0 0 0 0 1h8.976a.5.5 0 0 0 0-1z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }